import {
  defineNuxtPlugin, useGlobalStore, useNavigationStore
} from '#imports'

export default defineNuxtPlugin({
  parallel: true,
  setup (nuxtApp) {
    // console.log('[SERVER] 01.i18n.js')

    const nav = useNavigationStore()
    const global = useGlobalStore()
    // called right after a new locale has been set
    nuxtApp.hook('i18n:localeSwitched', async ({ oldLocale, newLocale }) => {
      await Promise.all([ nav.getNavigations(), global.getData() ])
    })
  }
})
